import {
  MY_TEAMS,
  PROFILE_ORDER_HISTORY,
  REPORT_ALL_CANDIDATES,
  REPORT_ALL_COACHES_IN_ORGANIZATION,
  REPORT_ALL_FRONTLINE_CLIENTS,
  REPORT_ALL_FRONTLINE_COACHES,
  REPORT_ALL_FRONTLINE_ORDERS,
  REPORT_ALL_GEN0_CLIENTS,
  REPORT_ALL_GEN0_COACHES,
  REPORT_ALL_GEN0_ORDERS,
  REPORT_ALL_ORDERS,
  REPORT_ALL_ORGANIZATION_CLIENTS,
  REPORT_ALL_ORGANIZATION_ORDERS,
  REPORT_ALL_REFERRALS,
  REPORT_BUSINESS_BUILDER_COACHES,
  REPORT_CLIENT_TO_CONTACT_EXPIRING_REWARDS,
  REPORT_CLIENT_TO_CONTACT_EXPIRING_WELLNESS_CREDITS,
  REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE,
  REPORT_CLIENT_TO_CONTACT_NEXT_TASK,
  REPORT_CLIENT_TO_CONTACT_NO_ACTIVE_ORDER,
  REPORT_CLIENT_TO_CONTACT_NO_ORDER,
  REPORT_CLIENT_TO_CONTACT_NO_RX_ORDER,
  REPORT_CLIENT_TO_CONTACT_PREMIER_CANCELATION,
  REPORT_CLIENT_TO_CONTACT_RECENTLY_INACTIVE,
  REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK,
  REPORT_CLOSE_TO_FIBC_RANK,
  REPORT_CLOSE_TO_SENIOR_COACH_RANK,
  REPORT_COACHES_ABOVE_RANK,
  REPORT_COACHES_AT_RANK,
  REPORT_COACHES_BELOW_RANK,
  REPORT_EARNED_ACCELERATOR_BONUS,
  REPORT_EARNED_CAB,
  REPORT_EARNED_CLIENT_SUPPORT_BONUS_PLUS,
  REPORT_EARNED_QSB,
  REPORT_ELIGIBLE_ACCELERATOR_BONUS,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR,
  REPORT_ELIGIBLE_FOR_CAB,
  REPORT_ELIGIBLE_FOR_INCENTIVE_TRIP,
  REPORT_ELIGIBLE_FOR_QSB,
  REPORT_EXPIRING_COACH_RENEWAL,
  REPORT_EXPIRING_REWARDS,
  REPORT_EXPIRING_WELLNESS,
  REPORT_FRONTLINE_COACHES,
  REPORT_INACTIVE_CLIENTS,
  REPORT_NEW_CLIENTS_WITHOUT_ORDERS,
  REPORT_NEW_COACHES_IN_ORGANIZATION,
  REPORT_NEW_FRONTLINE_CLIENTS,
  REPORT_NEW_FRONTLINE_COACHES,
  REPORT_NEW_FRONTLINE_ORDERS,
  REPORT_NEW_GEN0_CLIENTS,
  REPORT_NEW_GEN0_COACHES,
  REPORT_NEW_GEN0_ORDERS,
  REPORT_NEW_ORGANIZATION_CLIENTS,
  REPORT_NEW_ORGANIZATION_ORDERS,
  REPORT_NOT_CERTIFIED,
  REPORT_PREMIER_CANCELLATIONS,
  REPORT_PROJECTED_PREMIER_VOLUME,
  REPORT_QUALIFIED_FOR_INCENTIVE_TRIP,
  REPORT_RANK_UP,
  REPORT_TEAMS_EXECUTIVE_DIRECTOR,
  REPORT_TEAMS_FIBC,
  REPORT_TEAMS_FIBL,
  REPORT_TEAMS_SENIOR_COACH,
} from './records.enum';

export const DIRECTION_ASC = 'ASC';
export const DIRECTION_DESC = 'DESC';
export const DATE_ADDED = 'Date added';
export const OPTIONS = 'Options';
export const SORTS = {
  firstNameAZ: {
    key: 'firstNameAZ',
    label: 'First Name A → Z',
    params: {sortOrder: DIRECTION_ASC, sortBy: 'firstName'},
    description: 'Alphabetical by first name starting with A and going to Z',
    analylicsTag: 'first_name_a-z',
  },
  firstNameZA: {
    key: 'firstNameZA',
    label: 'First Name Z → A',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'firstName'},
    description: 'Alphabetical by first name starting with Z and going to A',
    analylicsTag: 'first_name_z-a',
  },
  lastNameAZ: {
    key: 'lastNameAZ',
    label: 'Last Name A → Z',
    params: {sortOrder: DIRECTION_ASC, sortBy: 'lastName'},
    description: 'Alphabetical by Last name starting with A and going to Z',
    analylicsTag: 'last_name_a-z',
  },
  lastNameZA: {
    key: 'lastNameZA',
    label: 'Last Name Z → A',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'lastName'},
    description: 'Alphabetical by Last name starting with Z and going to A',
    analylicsTag: 'last_name_z-a',
  },
  heighestqualifiedClientsToLowest: {
    key: 'heighestqualifiedClientsToLowest',
    label: 'Highest qualified Clients to lowest',
    params: {
      sortOrder: DIRECTION_DESC,
      sortBy: 'oe',
    },
    description: 'Highest qualified Clients to lowest',
    analylicsTag: 'heighestqualifiedClientsToLowest',
  },
  lowestqualifiedClientsToHighest: {
    key: 'lowestqualifiedClientsToHighest',
    label: 'Lowest qualified Clients to highest',
    params: {
      sortOrder: DIRECTION_ASC,
      sortBy: 'oe',
    },
    description: 'Lowest qualified Clients to highest',
    analylicsTag: 'lowestqualifiedClientsToHighest',
  },
  dateJoinedDesc: {
    key: 'dateJoinedDesc',
    label: 'Date Joined Descending',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'dateJoined'},
    description: 'Starts with the most recent date and goes to older',
    analylicsTag: 'date_joined_descending',
  },
  dateJoinedAsc: {
    key: 'dateJoinedAsc',
    label: 'Date Joined Ascending',
    params: {sortOrder: DIRECTION_ASC, sortBy: 'dateJoined'},
    description: 'Starts with the oldest and moves to most recent',
    analylicsTag: 'date_joined_ascending',
  },
  hraDesc: {
    key: 'hraDesc',
    label: 'HRA Descending',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'rank'},
    description:
      'Starts with the top Highest Rank Achieved and moves to the lowest Highest Rank Achieved',
  },
  hraAsc: {
    key: 'hraAsc',
    label: 'HRA Ascending',
    params: {sortOrder: DIRECTION_ASC, sortBy: 'rank'},
    description:
      'Starts with the lowest Highest Rank Achieved and moves to the top Highest Rank Achieved',
  },
  rankAsc: {
    key: 'rankAsc',
    label: 'Rank Ascending',
    params: {sortOrder: DIRECTION_ASC, sortBy: 'rank'},
    description: 'Starts with Lowest Rank and moves to Highest Rank',
    analylicsTag: 'rank_ascending',
  },
  rankDesc: {
    key: 'rankDesc',
    label: 'Rank Descending (Default)',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'rank'},
    description: 'Starts with Highest Rank and moves to Lowest Rank',
    analylicsTag: 'rank_descending',
  },
  activationDateNew: {
    key: 'activationDateOld',
    label: 'Activation Date (Oldest)',
    params: {sortOrder: DIRECTION_ASC, sortBy: 'date'},
    description: 'Activation Date (Oldest)',
    analylicsTag: 'activationDateOld',
  },
  activationDateOld: {
    key: 'activationDateNew',
    label: 'Activation Date (Newest)',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'date'},
    description: 'Activation Date (Newest)',
    analylicsTag: 'activationDateNew',
  },
  currentRankAsc: {
    key: 'currentRankAsc',
    label: 'Current Rank Ascending',
    params: {sortOrder: DIRECTION_ASC, sortBy: 'rank'},
    description: 'Starts with Lowest Rank and moves to Highest Rank',
  },
  currentRankDesc: {
    key: 'currentRankDesc',
    label: 'Current Rank Descending',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'rank'},
    description: 'Starts with Highest Rank and moves to Lowest Rank',
  },
  amountDesc: {
    key: 'amountDesc',
    label: 'Amount',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'amount'},
    description: 'Starts with the largest amount to smallest amount',
    analylicsTag: 'amount_descending_largest_to_smallest',
  },
  dateEarnedDesc: {
    key: 'dateEarnedDesc',
    label: 'Date Earned Descending',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'dateEarned'},
    description: 'Starts with the most recent date and goes to older',
  },
  eligibleEndsForward: {
    key: 'eligibleEndsForward',
    label: 'Date Eligibility Ends Forward',
    // TODO: Add the correct sort params once CDP has added sort options, this currently only works because
    // this is the default sort on the Eligible For Accelerator report when no params are sent
    params: {sortBy: 'dateEligibility'},
    description:
      'Starts with the soonest date that Coaches eligibility ends and moves to furthest out',
  },
  eligibleForCabThroughDesc: {
    key: 'eligibleForCabThroughDesc',
    label: 'Time Remaining',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'dateEligibility'},
    description:
      'Starts with the least amount of time remaining and moves to most time remaining',
  },
  generationDesc: {
    key: 'generationDesc',
    label: 'Generation',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'generation'},
    description: 'Starts with Frontline and moves to Gen 0 , Gen 1, Gen 2 ...',
  },
  dateExpiringDesc: {
    key: 'dateExpiringDesc',
    label: 'Date Expiring',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'expiryDate'},
    description: null,
  },
  dateExpiringAsc: {
    key: 'dateExpiringAsc',
    label: 'Date Expiring Forward',
    params: {sortOrder: DIRECTION_ASC, sortBy: 'expiryDate'},
    description:
      'Starts with the next soonest date first and moves to furthest out',
  },
  dateCancelledDesc: {
    key: 'dateCancelledDesc',
    label: 'Date Cancelled',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'dateCanceled'},
    description: 'Starts with the most recent date and goes to older',
    analylicsTag: 'date_canceled_descending',
  },
  dateCancelledAsc: {
    key: 'dateCancelledAsc',
    label: 'Date Cancelled',
    params: {sortOrder: DIRECTION_ASC, sortBy: 'dateCanceled'},
    description: 'Starts with the oldest and moves to most recent',
    analylicsTag: 'date_canceled_ascending',
  },
  lastOrderDesc: {
    key: 'lastOrderDesc',
    label: 'Last Order Descending',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'dateLastOrder'},
    description:
      'Starts with the most recent last order date and goes to oldest last order date',
  },
  lastOrderedDesc: {
    key: 'lastOrderedDesc',
    label: 'Date Ordered Descending',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'dateOrdered'},
    description: 'Starts with the most recent order date and goes to older',
  },
  orderDateDesc: {
    key: 'orderDateDesc',
    label: 'Last Order Descending',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'orderDate'},
    description:
      'Starts with the most recent last order date and goes to oldest last order date',
  },
  dateScheduledDesc: {
    key: 'dateScheduledDesc',
    label: 'Date Scheduled Descending',
    params: {
      sortOrder: DIRECTION_DESC,
      sortBy: 'dateScheduled',
    },
    description:
      'Starts with the next soonest date first and moves to furthest out',
  },
  dateScheduledAsc: {
    key: 'dateScheduledAsc',
    label: 'Scheduled Date Forward',
    params: {
      sortOrder: DIRECTION_ASC,
      sortBy: 'dateScheduled',
    },
    description:
      'Starts with the next soonest order by date and moves to furthest out',
  },
  wellnessExpiresOnDesc: {
    key: 'wellnessExpiresOnDesc',
    label: 'Expiration Date Descending',
    params: {
      sortOrder: DIRECTION_DESC,
      sortBy: 'expiryDate',
    },
    description: null,
  },
  wellnessExpiresOnAsc: {
    key: 'wellnessExpiresOnAsc',
    label: 'Expiration Date Forward',
    params: {
      sortOrder: DIRECTION_ASC,
      sortBy: 'expiryDate',
    },
    description:
      'Starts with the next soonest date first and moves to furthest out',
  },
  rewardExpiresOnDesc: {
    key: 'rewardExpiresOnDesc',
    label: 'Expiration Date Descending',
    params: {
      sortOrder: DIRECTION_DESC,
      sortBy: 'expirationDate',
    },
    description: null,
  },
  rewardExpiresOnAsc: {
    key: 'rewardExpiresOnAsc',
    label: 'Expiration Date Forward',
    params: {
      sortOrder: DIRECTION_ASC,
      sortBy: 'expirationDate',
    },
    description:
      'Starts with the next soonest date first and moves to furthest out',
    analylicsTag: 'expiration_date_forward',
  },
  dateInactiveAsc: {
    key: 'dateInactiveAsc',
    label: 'Date inactive Ascending',
    params: {
      sortOrder: DIRECTION_ASC,
      sortBy: 'dateInactive',
    },
    description:
      'Sort by the date the client became inactive, from the least to most recent',
    analylicsTag: 'date_inactive_ascending',
  },
  dateInactiveDesc: {
    key: 'dateInactiveDesc',
    label: 'Date inactive Descending',
    params: {
      sortOrder: DIRECTION_DESC,
      sortBy: 'dateInactive',
    },
    description:
      'Sort by the date the client became inactive, from the most to least recent',
    analylicsTag: 'date_inactive_descending',
  },
  earnedCsbPlusOn: {
    key: 'earnedCsbPlusOn',
    label: 'Date Earned Descending',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'earnedCsbPlusOn'},
    description: 'Starts with the most recent date and goes to older',
  },
  newestToOldest: {
    key: 'newestToOldest',
    label: 'Newest to oldest',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'dateAdded'},
    description: 'Starts with the most recent candidates and goes to older',
    analylicsTag: 'Newest to Oldest',
  },
  oldestToNewest: {
    key: 'oldestToNewest',
    label: 'Oldest to newest',
    params: {sortOrder: DIRECTION_ASC, sortBy: 'dateAdded'},
    description: 'Starts with the older candidates and goes to most recent',
    analylicsTag: 'Oldest to Newest',
  },
  disposition: {
    key: 'disposition',
    label: 'Disposition',
    params: {sortOrder: DIRECTION_ASC, sortBy: 'candidateDisposition'},
    description: 'Sort with candidate disposition',
  },
  newestToOldestDateJoined: {
    key: 'newestToOldestDateJoined',
    label: 'Newest to oldest',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'dateJoined'},
    description: 'Starts with the most recent coach and goes to older',
  },
  fcvHighToLow: {
    key: 'fcvHighToLow',
    label: 'FCV (high to low)',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'fcv'},
    description: 'Starts with coach with highest fcv and goes to lowest',
  },
  fcvLowToHigh: {
    key: 'fcvLowToHigh',
    label: 'FCV (low to High)',
    params: {sortOrder: DIRECTION_ASC, sortBy: 'fcv'},
    description: 'Starts with coach with lowest fcv and goes to highest',
  },
  profileOrderDateDesc: {
    key: 'profileOrderDateDesc',
    label: 'Order date, newest to oldest',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'orderDate'},
    description: 'Starts with the most recent order date and goes to older',
  },
  profileOrderDateAsc: {
    key: 'profileOrderDateAsc',
    label: 'Order date, oldest to newest',
    params: {sortOrder: DIRECTION_ASC, sortBy: 'orderDate'},
    description: 'Starts with the oldest order date and goes to most recent',
  },
  profileAmountDesc: {
    key: 'profileAmountDesc',
    label: 'Order total, high to low',
    params: {sortOrder: DIRECTION_DESC, sortBy: 'price'},
    description: 'Starts with highest order total and goes to lowest',
  },
  profileAmountAsc: {
    key: 'profileAmountAsc',
    label: 'Order total, low to high',
    params: {sortOrder: DIRECTION_ASC, sortBy: 'price'},
    description: 'Starts with lowest order total and goes to highest',
  },
};

export const RECORDS_SORTS = {
  [PROFILE_ORDER_HISTORY]: {
    default: SORTS.profileOrderDateDesc.key,
    items: [
      SORTS.profileOrderDateDesc,
      SORTS.profileOrderDateAsc,
      SORTS.profileAmountDesc,
      SORTS.profileAmountAsc,
    ],
  },
  [REPORT_ALL_ORDERS]: {
    default: 'orderDateDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.orderDateDesc,
      SORTS.amountDesc,
    ],
  },
  [REPORT_ALL_CANDIDATES]: {
    default: 'newestToOldest',
    // NOTE: When adding new sort options be sure to add them to AllCandidatesReduxKeys in redux/action/report.action as well.
    items: [SORTS.newestToOldest, SORTS.oldestToNewest, SORTS.disposition],
  },
  [REPORT_ALL_REFERRALS]: {
    default: 'newestToOldest',
    // NOTE: When adding new sort options be sure to add them to AllReferralReduxKeys in redux/action/report.action as well.
    items: [SORTS.newestToOldest, SORTS.oldestToNewest],
  },
  [REPORT_RANK_UP]: {
    default: SORTS.hraDesc.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.hraAsc,
      SORTS.hraDesc,
    ],
  },
  [REPORT_ALL_FRONTLINE_CLIENTS]: {
    default: 'dateJoinedDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.dateJoinedDesc,
      SORTS.dateJoinedAsc,
    ],
  },
  [REPORT_EARNED_CAB]: {
    default: SORTS.rankDesc.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.dateEarnedDesc,
      SORTS.generationDesc,
      SORTS.rankAsc,
      SORTS.rankDesc,
    ],
  },
  [REPORT_ELIGIBLE_ACCELERATOR_BONUS]: {
    default: SORTS.firstNameAZ.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.generationDesc,
    ],
  },

  [REPORT_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE]: {
    default: SORTS.firstNameAZ.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.heighestqualifiedClientsToLowest,
      SORTS.lowestqualifiedClientsToHighest,
    ],
  },

  [REPORT_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS]: {
    default: SORTS.lastNameAZ.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
    ],
  },

  [REPORT_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR]: {
    default: SORTS.firstNameAZ.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.heighestqualifiedClientsToLowest,
      SORTS.lowestqualifiedClientsToHighest,
    ],
  },
  [REPORT_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX]: {
    default: SORTS.firstNameAZ.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.heighestqualifiedClientsToLowest,
      SORTS.lowestqualifiedClientsToHighest,
    ],
  },
  [REPORT_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO]: {
    default: SORTS.firstNameAZ.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.heighestqualifiedClientsToLowest,
      SORTS.lowestqualifiedClientsToHighest,
    ],
  },
  [REPORT_EARNED_CLIENT_SUPPORT_BONUS_PLUS]: {
    default: SORTS.rankDesc.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.earnedCsbPlusOn,
      SORTS.rankAsc,
      SORTS.rankDesc,
    ],
  },
  [REPORT_EARNED_ACCELERATOR_BONUS]: {
    default: SORTS.generationDesc.key,
    items: [SORTS.generationDesc],
  },
  [REPORT_EARNED_QSB]: {
    default: SORTS.rankDesc.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.dateEarnedDesc,
      //SORTS.generationDesc, // TODO: put back once CDP fixes sort
      SORTS.rankAsc,
      SORTS.rankDesc,
    ],
  },
  [REPORT_NEW_FRONTLINE_COACHES]: {
    default: 'dateJoinedDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.dateJoinedDesc,
      SORTS.dateJoinedAsc,
    ],
  },
  [REPORT_ALL_FRONTLINE_COACHES]: {
    default: 'dateJoinedDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.dateJoinedDesc,
      SORTS.rankAsc,
      SORTS.rankDesc,
    ],
  },
  [REPORT_FRONTLINE_COACHES]: {
    default: 'dateJoinedDesc',
    items: [SORTS.dateJoinedDesc],
  },
  [REPORT_NEW_GEN0_COACHES]: {
    default: 'dateJoinedDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.dateJoinedDesc,
      SORTS.dateJoinedAsc,
    ],
  },
  [REPORT_ALL_GEN0_COACHES]: {
    default: 'dateJoinedDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.dateJoinedDesc,
      SORTS.currentRankAsc,
      SORTS.currentRankDesc,
    ],
  },
  [REPORT_NEW_COACHES_IN_ORGANIZATION]: {
    default: 'dateJoinedDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.dateJoinedDesc,
    ],
  },
  [REPORT_ALL_COACHES_IN_ORGANIZATION]: {
    default: 'dateJoinedDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.dateJoinedDesc,
      SORTS.rankAsc,
      SORTS.rankDesc,
    ],
  },
  [MY_TEAMS]: {
    default: 'rankDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.rankAsc,
      SORTS.rankDesc,
      SORTS.activationDateNew,
      SORTS.activationDateOld,
    ],
  },
  [REPORT_TEAMS_SENIOR_COACH]: {
    default: 'firstNameAZ',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
    ],
  },
  [REPORT_TEAMS_EXECUTIVE_DIRECTOR]: {
    default: 'firstNameAZ',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
    ],
  },
  [REPORT_TEAMS_FIBC]: {
    default: 'firstNameAZ',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
    ],
  },
  [REPORT_TEAMS_FIBL]: {
    default: 'firstNameAZ',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
    ],
  },
  [REPORT_COACHES_ABOVE_RANK]: {
    default: 'rankDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.rankDesc,
      SORTS.rankAsc,
    ],
  },
  [REPORT_COACHES_AT_RANK]: {
    default: 'rankDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.rankDesc,
      SORTS.rankAsc,
    ],
  },
  [REPORT_COACHES_BELOW_RANK]: {
    default: 'rankDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.rankDesc,
      SORTS.rankAsc,
    ],
  },
  [REPORT_ELIGIBLE_FOR_CAB]: {
    default: 'eligibleForCabThroughDesc',
    items: [SORTS.eligibleForCabThroughDesc],
  },
  [REPORT_ELIGIBLE_FOR_QSB]: {
    default: 'eligibleEndsForward',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.eligibleEndsForward,
    ],
  },
  [REPORT_NOT_CERTIFIED]: {
    default: SORTS.generationDesc.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.rankDesc,
      SORTS.rankAsc,
      SORTS.generationDesc,
    ],
  },
  [REPORT_EXPIRING_COACH_RENEWAL]: {
    default: SORTS.dateExpiringAsc.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.rankDesc,
      SORTS.rankAsc,
      SORTS.dateExpiringAsc,
    ],
  },
  [REPORT_CLOSE_TO_SENIOR_COACH_RANK]: {
    default: SORTS.firstNameAZ.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
    ],
  },
  [REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK]: {
    default: 'firstNameAZ',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
    ],
  },
  [REPORT_CLOSE_TO_FIBC_RANK]: {
    default: 'firstNameAZ',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
    ],
  },
  [REPORT_PREMIER_CANCELLATIONS]: {
    default: 'dateCancelledDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.generationDesc,
      SORTS.dateCancelledDesc,
    ],
  },
  [REPORT_NEW_CLIENTS_WITHOUT_ORDERS]: {
    default: 'dateJoinedDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.dateJoinedDesc,
      SORTS.dateJoinedAsc,
    ],
  },
  [REPORT_INACTIVE_CLIENTS]: {
    default: 'lastOrderDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.lastOrderDesc,
    ],
  },
  [REPORT_NEW_FRONTLINE_CLIENTS]: {
    default: 'dateJoinedDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.dateJoinedDesc,
      SORTS.dateJoinedAsc,
    ],
  },
  [REPORT_NEW_GEN0_CLIENTS]: {
    default: 'dateJoinedDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.dateJoinedDesc,
      SORTS.dateJoinedAsc,
    ],
  },
  [REPORT_ALL_GEN0_CLIENTS]: {
    default: 'dateJoinedDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.dateJoinedDesc,
      SORTS.dateJoinedAsc,
    ],
  },
  [REPORT_NEW_ORGANIZATION_CLIENTS]: {
    default: 'dateJoinedDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.dateJoinedDesc,
      SORTS.dateJoinedAsc,
      SORTS.generationDesc,
    ],
  },
  [REPORT_ALL_ORGANIZATION_CLIENTS]: {
    default: SORTS.dateJoinedDesc.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.dateJoinedDesc,
      SORTS.dateJoinedAsc,
    ],
  },
  [REPORT_NEW_FRONTLINE_ORDERS]: {
    default: 'lastOrderedDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      //SORTS.generationDesc, // TODO: put back once CDP fixes sort
      SORTS.lastOrderedDesc,
      SORTS.amountDesc,
    ],
  },
  [REPORT_ALL_FRONTLINE_ORDERS]: {
    default: 'lastOrderedDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.lastOrderedDesc,
      SORTS.amountDesc,
    ],
  },
  [REPORT_NEW_GEN0_ORDERS]: {
    default: 'lastOrderedDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.lastOrderedDesc,
      SORTS.amountDesc,
    ],
  },
  [REPORT_ALL_GEN0_ORDERS]: {
    default: 'lastOrderedDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.lastOrderedDesc,
      SORTS.amountDesc,
    ],
  },
  [REPORT_NEW_ORGANIZATION_ORDERS]: {
    default: 'lastOrderedDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.generationDesc,
      SORTS.lastOrderedDesc,
      SORTS.amountDesc,
    ],
  },
  [REPORT_ALL_ORGANIZATION_ORDERS]: {
    default: 'lastOrderedDesc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.generationDesc,
      SORTS.lastOrderedDesc,
      SORTS.amountDesc,
    ],
  },
  [REPORT_PROJECTED_PREMIER_VOLUME]: {
    default: 'dateScheduledAsc',
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.generationDesc,
      SORTS.dateScheduledAsc,
      SORTS.amountDesc,
    ],
  },
  [REPORT_EXPIRING_REWARDS]: {
    default: SORTS.rewardExpiresOnAsc.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.amountDesc,
      SORTS.rewardExpiresOnAsc,
    ],
  },
  [REPORT_EXPIRING_WELLNESS]: {
    default: SORTS.wellnessExpiresOnAsc.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.amountDesc,
      SORTS.wellnessExpiresOnAsc,
    ],
  },
  [REPORT_CLIENT_TO_CONTACT_PREMIER_CANCELATION]: {
    default: SORTS.dateCancelledDesc.key,
    items: [
      SORTS.dateCancelledDesc,
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
    ],
  },
  [REPORT_CLIENT_TO_CONTACT_NO_ORDER]: {
    default: SORTS.dateJoinedDesc.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.dateJoinedDesc,
      SORTS.dateJoinedAsc,
    ],
  },
  [REPORT_CLIENT_TO_CONTACT_RECENTLY_INACTIVE]: {
    default: SORTS.dateInactiveDesc.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.dateInactiveDesc,
      SORTS.dateInactiveAsc,
    ],
  },
  [REPORT_CLIENT_TO_CONTACT_EXPIRING_REWARDS]: {
    default: SORTS.rewardExpiresOnAsc.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.amountDesc,
      SORTS.rewardExpiresOnAsc,
    ],
  },
  [REPORT_CLIENT_TO_CONTACT_EXPIRING_WELLNESS_CREDITS]: {
    default: SORTS.rewardExpiresOnAsc.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.amountDesc,
      SORTS.rewardExpiresOnAsc,
    ],
  },
  [REPORT_CLIENT_TO_CONTACT_NEXT_TASK]: {
    default: SORTS.dateJoinedDesc.key,
    items: [SORTS.dateJoinedDesc, SORTS.firstNameAZ, SORTS.firstNameZA],
  },
  [REPORT_CLIENT_TO_CONTACT_NO_ACTIVE_ORDER]: {
    default: SORTS.lastOrderedDesc.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.lastOrderedDesc,
    ],
  },
  [REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE]: {
    default: 'newestToOldest',
    items: [SORTS.newestToOldest, SORTS.oldestToNewest],
  },
  [REPORT_CLIENT_TO_CONTACT_NO_RX_ORDER]: {
    default: SORTS.lastOrderedDesc.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.lastOrderedDesc,
    ],
  },
  [REPORT_ELIGIBLE_FOR_INCENTIVE_TRIP]: {
    default: SORTS.rankDesc.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.rankDesc,
      SORTS.rankAsc,
    ],
  },
  [REPORT_QUALIFIED_FOR_INCENTIVE_TRIP]: {
    default: SORTS.rankDesc.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.rankDesc,
      SORTS.rankAsc,
    ],
  },
  [REPORT_BUSINESS_BUILDER_COACHES]: {
    default: SORTS.newestToOldestDateJoined.key,
    items: [
      SORTS.firstNameAZ,
      SORTS.firstNameZA,
      SORTS.lastNameAZ,
      SORTS.lastNameZA,
      SORTS.fcvHighToLow,
      SORTS.fcvLowToHigh,
      SORTS.newestToOldestDateJoined,
    ],
  },
};
